import React from 'react'
import styled from 'styled-components'

import Color from 'helpers/Color'

const Wrapper = styled.div`
  background-color: ${Color.white};
  border-radius: 10px;
  height: ${({autoHeight}) => (autoHeight ? 'auto' : '100%')};
  margin: auto;
  padding: 0 20px;
`
const Child = styled.div`
  padding: 20px 0;
  text-align: ${({centered}) => centered ? 'center' : 'left'};
  &:not(:first-child) {
    border-top: solid 1px ${Color.lightGray};
  }
`

const Segment = ({ children, autoHeight, centered, ...rest }) => {
  const content = Array.isArray(children) ? (
    children.map((child, index) => (
      <Child
        key={index}
        centered={centered}
      >
        {child}
      </Child>
    ))) : (
      <Child centered={centered}>
        {children}
      </Child>
    )

  return (
    <Wrapper
      autoHeight={autoHeight}
      {...rest}
    >
      {content}
    </Wrapper>
  )
}

Segment.Child = Child

export default Segment



// WEBPACK FOOTER //
// ./src/components/UI/Segment.jsx